import React from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';

import Container from '../../_layouts/Container/';
import ContainerFluid from '../../_layouts/ContainerFluid/';
import AuthorizedRoute from '../../_helpers/authorized.route.js';

import List from './List/';
import Schedule from './Schedule/';
import ViewQuestionnaire from './ViewQuestionnaire/';

export default () => {
  let { path } = useRouteMatch();

  return (
    <Switch>
      <AuthorizedRoute path={`${path}/schedule`} layout={Container} component={Schedule} />
      <AuthorizedRoute path={`${path}/:id/view`} layout={ContainerFluid} component={ViewQuestionnaire} />
      <AuthorizedRoute path={`${path}`} layout={ContainerFluid} component={List} />
    </Switch>
  );
}